'use client';
import styles from './style.module.scss';
import { motion } from 'framer-motion';
import { mountAnim, rotateX } from '../anim';
import React, { useRef, MouseEvent } from 'react';
import gsap from 'gsap';

interface LinkProps {
    data: {
        link: string;
        title: string;
        redirect_to: boolean;
        description: string[];
        images: string[];
    };
    index: number;
}

const Link: React.FC<LinkProps> = ({ data, index }) => {
    const { link, title, description, images } = data;
    const outer = useRef<HTMLDivElement>(null);
    const inner = useRef<HTMLDivElement>(null);

    const manageMouseEnter = (e: MouseEvent<HTMLDivElement>) => {
        const bounds = e.currentTarget.getBoundingClientRect();
        if (e.clientY < bounds.top + bounds.height / 2) {
            gsap.set(outer.current, { top: "-100%" });
            gsap.set(inner.current, { top: "100%" });
        } else {
            gsap.set(outer.current, { top: "100%" });
            gsap.set(inner.current, { top: "-100%" });
        }
        gsap.to(outer.current, { top: "0%", duration: 0.3 });
        gsap.to(inner.current, { top: "0%", duration: 0.3 });
    };

    const manageMouseLeave = (e: MouseEvent<HTMLDivElement>) => {
        const bounds = e.currentTarget.getBoundingClientRect();
        if (e.clientY < bounds.top + bounds.height / 2) {
            gsap.to(outer.current, { top: "-100%", duration: 0.3 });
            gsap.to(inner.current, { top: "100%", duration: 0.3 });
        } else {
            gsap.to(outer.current, { top: "100%", duration: 0.3 });
            gsap.to(inner.current, { top: "-100%", duration: 0.3 });
        }
    };

    return (
        <motion.div
            onMouseEnter={manageMouseEnter}
            onMouseLeave={manageMouseLeave}
            variants={rotateX}
            {...mountAnim}
            custom={index}
            className={styles.el}
        >
            <a href={link} target={data.redirect_to ? "_blank" : "_self"} rel="noreferrer">{title}</a>
            <div ref={outer} className={styles.outer}>
                <div ref={inner} className={styles.inner}>
                    {[...Array(2)].map((_, idx) => (
                        <div key={idx} className={styles.container}>
                            <div className={styles.imageContainer}>
                                <img src={`../pettern/${images[0]}`} alt="image" />
                            </div>
                            <p>{description[0]}</p>
                            <div className={styles.imageContainer}>
                                <img src={`../pettern/${images[1]}`} alt="image" />
                            </div>
                            <p>{description[1]}</p>
                        </div>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default Link;
